import { render, staticRenderFns } from "./estimate_approve_details.vue?vue&type=template&id=b2dd9b62&scoped=true"
import script from "./estimate_approve_details.vue?vue&type=script&lang=js"
export * from "./estimate_approve_details.vue?vue&type=script&lang=js"
import style0 from "./estimate_approve_details.vue?vue&type=style&index=0&id=b2dd9b62&prod&scoped=true&lang=css"
import style1 from "./estimate_approve_details.vue?vue&type=style&index=1&id=b2dd9b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dd9b62",
  null
  
)

export default component.exports